<template>
  <div class="check-box-root">
    <input
      class="check-box-input"
      type="checkbox"
      v-bind="$attrs"
      @change="$emit('input', $event.target.checked)"
      :checked="value"
    />
    <div v-if="value" class="check-box-image">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.025"
        height="11.725"
        viewBox="0 0 16.025 11.725"
        fill="currentColor"
      >
        <path
          id="Confirm_ikonica_BOX"
          d="M16.5 1.2a1.871 1.871 0 0 0-2.6 0L6.9 8 4.1 5.3a1.871 1.871 0 0 0-2.6 0 2 2 0 0 0 0 2.7l4.1 3.9a1.9 1.9 0 0 0 1.3.5 2.106 2.106 0 0 0 1.3-.5l8.3-8a2.654 2.654 0 0 0 .5-1.4 1.9 1.9 0 0 0-.5-1.3z"
          transform="translate(-.975 -.675)"
        />
      </svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.check-box-root {
  width: auto;
  height: auto;
  border: 1px solid black;
  position: relative;
  border-radius: 4px;
  color: $text_white;

  .check-box-image {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    max-width: 100%;
    height: auto;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check-box-input {
    appearance: none;
    background-color: transparent;
    outline: none;
    border: none;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    width: 100%;
  }
}
</style>

<script>
export default {
  props: {
    value: Boolean,
  },
  inheritAttrs: false,
};
</script>
